/* global  */ // tUrl等のグローバル変数を宣言する

import 'core-js/features/number/is-nan'
import 'custom-event-polyfill'
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

/*
  ######   ######  ########   #######  ##       ##
 ##       ##       ##     ## ##     ## ##       ##
  ######  ##       ########  ##     ## ##       ##
       ## ##       ##   ##   ##     ## ##       ##
  ######   ######  ##     ##  #######  ######## ########
*/
/**
 * @function scrollValToggle
 * @description スクロール量を基準にクラスを着脱する
 * @param {String} targetSelector ターゲットとする一意なセレクタ
 * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
 * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
 * @param {String} toggleClass 切り替えるクラス名
 * @return {Void}
scrollValToggle('#hogeID', 500, false,'active')
 */
scrollValToggle('#pagetop', 300, 300, 'active')
function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  let isExecute = false // 実行中フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleActive = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply() // 初回起動
  function scrollValToggleApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.pageYOffset // スクロール量
      if (scrollY >= scrollValStart && !scToggleActive) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleActive = true
      } else if (scrollY < scrollValStart && scToggleActive) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleActive = false
      }
      if (scrollValEnd && scToggleActive) {
        // 終了ラインが設定されている場合は終了判定
        if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
          //スクロール終了範囲を過ぎていたらOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
      }
      isExecute = false
    })
  }
}

/*
######## ########  ##     ## ##    ## ##    ##  #######
   ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
   ##    ########  ##     ## ## ## ## #####     #######
   ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
   ##    ##     ##  #######  ##    ## ##    ##  #######
*/
function trunk8() {
  // 指定要素に行数制限をかける
  $('.js-t8.line1').trunk8({
    lines: 1,
    fill: '...',
  })
}
if ($('.js-t8')[0]) {
  // 要素を検出したら実行
  trunk8()
  $(window).on('load resize', function () {
    trunk8()
  })
}

/*
        ##  ######          #### ##    ##
        ## ##                ##  ####  ##
        ##  ######  #######  ##  ## ## ##
  ##    ##       ##          ##  ##  ####
   ######   ######          #### ##    ##
*/
if (document.getElementsByClassName('js-in')[0]) {
  // 画面に入った監視対象に.animatedを付加
  // Intersection Observer
  intObs()
}
function intObs() {
  let rootMargin = '-10px 0px'
  if (window.matchMedia('(max-width:768px)').matches) {
    //SPは検出を早くする
    rootMargin = '100px 0px'
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('active')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}

if ($('.category__list-item-news')) {
  $('.category__list-item-news')
    .find('a')
    .each(function () {
      //アクティブ検証
      var ct = location.href.replace(location.hash, '') //カレントURL取得（#ID除外）
      console.log(ct)
      if (ct.indexOf('category/') === -1) {
        $(this).parent().addClass('active')
      }
    })
}

/*
 ########  #######  ########          ##    ##    ###    ##     ##
    ##    ##     ## ##     ##         ###   ##   ## ##   ##     ##
    ##    ##     ## ##     ##         ####  ##  ##   ##  ##     ##
    ##    ##     ## ########  ####### ## ## ## ##     ## ##     ##
    ##    ##     ## ##                ##  #### #########  ##   ##
    ##    ##     ## ##                ##   ### ##     ##   ## ##
    ##     #######  ##                ##    ## ##     ##    ###
*/
$(function () {
  var position = $('.topNav').position().top
  $(window).resize(function () {
    position = $('.topNav').position().top
  })
  $(window).scroll(function () {
    var scroll = $(this).scrollTop()
    if (scroll >= position) {
      $('.topNav').addClass('fixed')
    } else {
      $('.topNav').removeClass('fixed')
    }
  })
})

/*
 ##     ## ##     ##          ######  ##    ## ##    ##  ######
 ##     ## ##     ##         ##         ####   ####  ## ##
 ######### ##     ## #######  ######     ##    ## ## ## ##
 ##     ##  ##   ##                ##    ##    ##  #### ##
 ##     ##    ###             ######     ##    ##    ##  ######
ホバー中、その要素とその連動要素全てに.hoverを付与

<a href="" class="js-hoverSync js-hoverSync--hoge" data-hover-sync="hoge"></a>
<a href="" class="js-hoverSync js-hoverSync--hoge" data-hover-sync="hoge"></a>
*/
const hoverSyncClass = 'js-hoverSync'
if (document.getElementsByClassName(hoverSyncClass)[0]) {
  hoverSync()
}
function hoverSync() {
  const hoverActiveClass = 'hover'
  const hoverItems = document.getElementsByClassName(hoverSyncClass)
  for (let index = 0; index < hoverItems.length; index++) {
    const hoverItem = hoverItems[index]
    const hoverTargets = document.getElementsByClassName(hoverSyncClass + '--' + hoverItem.dataset.hoverSync)
    hoverItem.addEventListener(
      'mouseover',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.add(hoverActiveClass)
        }
      },
      false
    )
    hoverItem.addEventListener(
      'mouseout',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.remove(hoverActiveClass)
        }
      },
      false
    )
  }
}

var mySwiper = new Swiper('.swiper-container', {
  effect: 'slide', // slide,fade,cube,coverflow
  speed: 10000, // アニメ速度
  loop: true, // ループ
  freeMode: true,
  loopAdditionalSlides: 6,
  spaceBetween: 0, //スライド同士の間隔を空ける
  autoplay: {
    delay: 0, // 待機時間
    disableOnInteraction: false, // 操作されたらオート解除
  },
})

$(function () {
  $('.sp-title-1').click(function () {
    $('.toggle-menu-1').slideToggle()
    $(this).children('.down-arrow').toggleClass('reverse')
  })
  $('.sp-title-2').click(function () {
    $('.toggle-menu-2').slideToggle()
    $(this).children('.down-arrow').toggleClass('reverse')
  })
  $('.sp-title-3').click(function () {
    $('.toggle-menu-3').slideToggle()
    $(this).children('.down-arrow').toggleClass('reverse')
  })
  $('.sp-title-4').click(function () {
    $('.toggle-menu-4').slideToggle()
    $(this).children('.down-arrow').toggleClass('reverse')
  })
})
